//@flow

import styled from "styled-components"
import * as BaseUI from "../UI"

export const TitleText = BaseUI.TitleText

export const TitleDescription = BaseUI.TitleDescription

export const ContentContainer = styled.div`
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  position: absolute;
  background: #a5d9f2;
`

export const Titles = styled.div`
  position: absolute;
  top: 104px;
  left: 124px;
  width: 600px;
  z-index: 4;
`

export const WalkMonster = styled.div`
  position: absolute;
  top: 144px;
  right: 250px;
  height: 524px;
  width: 606px;
  z-index: 2;
`

export const Midground = styled.div`
  position: absolute;
  bottom: 0;
  left: -200px;
  height: 792px;
  width: 2122px;
  z-index: 1;
`

export const Background = styled.div`
  position: absolute;
  top: 0;
  left: -227px;
  height: 498px;
  width: 2180px;
  z-index: 0;
`



// WEBPACK FOOTER //
// ./src/Kiosk/CommitView/Walk/UI.js